import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import axios from 'axios'
import store from './store'
import './plugins/base'
import ImageLoader from './components/Common/imageLoader'
Vue.component('ImageLoader', ImageLoader)

import VueElementLoading from 'vue-element-loading'
Vue.component('VueElementLoading', VueElementLoading)
import OwlCarousel from 'vue-owl-carousel'
Vue.component('OwlCarousel', OwlCarousel)
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
    // import Viewer from 'v-viewer'
    // Vue.use(Viewer)
    // import 'viewerjs/dist/viewer.css'
import ServerError from './components/Common/500'
Vue.component('ServerError', ServerError)

window.axios = require('axios')

// Vue.prototype.mediaUURL = "https://mudumalaitigereserve.s3.ap-south-1.amazonaws.com/"
// axios.defaults.baseURL = "http://192.168.55.194:4400";
// Vue.prototype.mediaURL = "http://192.168.55.194:4400/wp/";
// Vue.prototype.ipURL = "http://192.168.55.194:4400"

Vue.prototype.mediaUURL = "https://mudumalaitigereserve.s3.ap-south-1.amazonaws.com/"
axios.defaults.baseURL = "https://api.mudumalaiecoshop.com";
// Vue.prototype.mediaURL = "https://api.mudumalaiecoshop.com/wp/";
Vue.prototype.ipURL = "https://api.mudumalaiecoshop.com"

axios.defaults.timeout = 60000;



Vue.config.productionTip = false

new Vue({
    vuetify,
    store,
    router,

    render: h => h(App)
}).$mount('#app')